import { getParsedEthersError } from "@enzoferey/ethers-error-parser";
import { message } from "antd";

export const handleEthersError = (err: any) => {
  const parsedEthersError = getParsedEthersError(err);

  if (!isNaN(Number(parsedEthersError.context))) {
    if (err.message.includes("execution reverted")) {
      message.error(err.message.substr(0, err.message.indexOf("{")));
    } else {
      message.error(err.message);
    }
  } else {
    message.error(
      parsedEthersError.context ?? "Error when sending transaction"
    );
  }
};
